/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* Back to top button */
(function () {
  var button = document.querySelector('[data-back-to-top]');

  if (!button) {
    return;
  }

  var offset = parseInt(button.getAttribute('data-scroll-offset'), 10) || 700;
  var ticking = false;

  function update() {
    button.classList.toggle('is-visible', window.pageYOffset > offset);
    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  update();

  button.addEventListener('click', function () {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
  });
})();

/* Mobile sticky add-to-cart bar */
(function () {
  var bar = document.querySelector('[data-sticky-atc]');
  if (!bar) { return; }

  var info = document.getElementById(bar.getAttribute('data-info-id'));
  if (!info) { return; }

  var stickyPrice = bar.querySelector('[data-sticky-atc-price]');
  var stickyImage = bar.querySelector('[data-sticky-atc-image]');
  var stickyButton = bar.querySelector('[data-sticky-atc-button]');

  // Sticky button simply triggers the real Add to cart button (keeps a single form / variant source)
  if (stickyButton) {
    stickyButton.addEventListener('click', function () {
      var realButton = info.querySelector('.product-form__add-button');
      if (realButton && !realButton.disabled) {
        realButton.click();
      }
    });
  }

  // Mirror the live price (handles compare-at, currency, etc.) into the sticky bar
  function mirrorPrice() {
    var livePrice = info.querySelector('.price-list');
    if (livePrice && stickyPrice) {
      stickyPrice.innerHTML = livePrice.innerHTML;
    }
  }

  function setButtonAvailability(available) {
    if (!stickyButton) { return; }
    if (available === false) {
      stickyButton.setAttribute('disabled', 'disabled');
      stickyButton.classList.add('button--disabled');
    } else {
      stickyButton.removeAttribute('disabled');
      stickyButton.classList.remove('button--disabled');
    }
  }

  document.addEventListener('variant:changed', function (event) {
    var variant = event.detail && event.detail.variant;

    // Re-mirror the price after the theme has updated the DOM
    window.requestAnimationFrame(mirrorPrice);

    if (!variant) { return; }

    setButtonAvailability(variant.available);

    if (stickyImage && variant.featured_image && variant.featured_image.src) {
      // Request a small, crisp thumbnail from the Shopify CDN URL
      stickyImage.src = variant.featured_image.src.replace(/(\.[a-z0-9]+)(\?|$)/i, '_200x$1$2');
    }
  });

  // Keep price in sync after partial re-renders too
  info.addEventListener('product:rerender', function () {
    window.requestAnimationFrame(mirrorPrice);
  });

  // Reveal the bar once the real buy buttons scroll out of view
  var anchor = info.querySelector('.product-form__buy-buttons') || info.querySelector('.product-form__add-button');

  if (anchor && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-visible', !entries[0].isIntersecting);
      bar.setAttribute('aria-hidden', entries[0].isIntersecting ? 'true' : 'false');
    }, { threshold: 0 });

    observer.observe(anchor);
  } else {
    // Fallback: reveal after scrolling a bit
    window.addEventListener('scroll', function () {
      var show = window.pageYOffset > 600;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    }, { passive: true });
  }

  mirrorPrice();
})();

